<template>
  <div id="app">
    <router-view :key="viewKey" />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    // Keep Integrations mounted when only the category filter URL changes
    viewKey() {
      const { name, fullPath } = this.$route;
      if (name === "Integrations" || name === "IntegrationsCats") {
        return "Integrations";
      }
      return fullPath;
    },
  },
};
</script>

<style></style>
